import { useMemo, type FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { BaseDrawer, DrawerContentStyled, DrawerHeader } from "@ryde/layout";
import { useReportMenuItems } from "@ryde/redux";
import {
  filterAndTranslateReportMenuItemsData,
  reportNavigationSearchAtom,
  reportsNavigationDrawerAtom,
  useIsMobile,
} from "@ryde/shared";

import { ReportNavigationGroup } from "./report-navigation.group";
import { ReportNavigationMobileSettingsSearch } from "./report-navigation.mobile-settings-search";
import { ReportNavigationContainerStyled } from "./report-navigation.styled";

export const ReportNavigationDrawer: FC = () => {
  const { t } = useTranslation();
  const setReportNavigationDrawerOpenState = useSetRecoilState(
    reportsNavigationDrawerAtom,
  );
  const { reportMenuItems } = useReportMenuItems();
  const { isMobile } = useIsMobile();

  const menuSearchText = useRecoilValue(reportNavigationSearchAtom);

  const menuItemsDataFiltered = useMemo(() => {
    if (!reportMenuItems?.length) {
      return [];
    }

    return filterAndTranslateReportMenuItemsData({
      itemsRaw: reportMenuItems,
      searchText: menuSearchText,
      t,
    });
  }, [menuSearchText, reportMenuItems, t]);

  const onRightBarCloseClick = (): void => {
    setReportNavigationDrawerOpenState(false);
  };

  return (
    <BaseDrawer onCloseDrawer={onRightBarCloseClick}>
      <DrawerHeader
        title={t("general.REPORTS")}
        onCloseDrawer={onRightBarCloseClick}
      />
      <DrawerContentStyled className="drawer-form-with-image isAdmin">
        <ReportNavigationContainerStyled>
          {!isMobile && <ReportNavigationMobileSettingsSearch />}

          {menuItemsDataFiltered?.map(item => (
            <ReportNavigationGroup
              key={item.id}
              {...item}
            ></ReportNavigationGroup>
          ))}
        </ReportNavigationContainerStyled>
      </DrawerContentStyled>
    </BaseDrawer>
  );
};
